import { render, staticRenderFns } from "./CategoriesSlider.vue?vue&type=template&id=9b8b98e4"
import script from "./CategoriesSlider.vue?vue&type=script&lang=js"
export * from "./CategoriesSlider.vue?vue&type=script&lang=js"
import style0 from "./CategoriesSlider.vue?vue&type=style&index=0&id=9b8b98e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports